module.exports = __webpack_public_path__ + "static/fonts/montserrat-v29-cyrillic_cyrillic-ext_latin_latin-ext-300italic.6b46236.woff2";